
















































import { Vue, Component } from 'vue-property-decorator'
import store from '@/store'
import { processAudience, translateCriteria } from '@/utilities/audience-mappers'
import { format as dateFormat, fromUnixTime } from 'date-fns'

@Component
export default class TestOverview extends Vue {
  get hasInsights () {
    return store.getters.survey.insights.length
  }

  get testData () {
    return store.state.surveyConfiguration.testMetaDetails
  }

  get audience () {
    if (!this.testData?.audience) return
    return processAudience(this.testData?.audience)
  }

  get translatedCriteria () {
    if (!this.audience || !this.audience.criteria) return []
    return translateCriteria(this.audience.criteria)
  }

  get testType () {
    return this.testData?.type
  }

  get nSize () {
    return store.getters.survey.respondentCount
  }

  get completedAt () {
    const time:Date = fromUnixTime(this.testData?.completedAt)
    return dateFormat(time, 'MMM dd, yyyy')
  }
}
